import React from 'react';
import {Th, Tr, Thead} from "../StatisticDesign"

const StatisticTableHead = ({Dates}) => {
    return (
        <Thead>
        <Tr>
            <Th></Th>
            <Th/>
            <Th/>
            {
                Dates?.map(Date =>{
                    return (
                        <Th>
                            {
                                Date
                            }
                        </Th>)
                })
            }
        </Tr>
        </Thead>
    );
};

export default StatisticTableHead;